import React, { useEffect, useState } from "react";
import { Box, Container, FormControl, FormLabel, Select } from "@chakra-ui/react";
import { ContentControls } from "./ContentControls";
import '@mdxeditor/editor/style.css';
import './TextContentElement.css';
import { ContentArea } from "./ContentArea";
import { useFocus } from "./useFocus";
const defaults = {
    children: [],
    color: "transparent"
};
function isContainer(element) {
    return element.type === "container";
}
export const ContainerContentElement = (props) => {
    const [ref, setRef] = useState(null);
    const { containerProps, isActive } = useFocus(props.contentElement.id);
    useEffect(() => {
        if (!isContainer(props.contentElement) || props.contentElement.data == null) {
            const element = Object.assign(Object.assign({}, props.contentElement), { type: "container", data: defaults });
            props.onChange(element);
        }
    }, [props.contentElement]);
    if (!isContainer(props.contentElement) || props.contentElement.data == null) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Box, Object.assign({ ref: setRef, bg: props.contentElement.data.color, py: 12, w: "100%" }, containerProps),
        ref && isActive &&
            React.createElement(ContentControls, { onUp: props.onUp, onDown: props.onDown, onDelete: props.onDelete, label: "Container", attachTo: ref },
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Color"),
                    React.createElement(Select, { value: props.contentElement.data.color, onChange: event => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { color: event.target.value }) })) },
                        React.createElement("option", { value: "transparent" }, "None"),
                        React.createElement("option", { value: "gray.50" }, "Gray")))),
        React.createElement(Container, null,
            React.createElement(Box, { px: [0, 6] },
                React.createElement(ContentArea, { attachControlsTo: ref, showAdd: isActive, contentElements: props.contentElement.data.children, onChange: elements => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { children: elements }) })), allowedTypes: ["stack", "image", "text", "title", "box", "form", "snippet", "faq", "video"] })))));
};
